import {customElement} from 'aurelia-framework';

@customElement('search-user-communication-frame')
export class SearchUserCommunicationFrame {
}
